import { z } from 'my-zod'
import { ActionPlanTriggers as Models } from './action-plan-triggers-model'

const TriggerBase = Models.TriggerBase.augment({
  createdPlansCount: z.number(),
  createdTasksCount: z.number(),
  completedTasksCount: z.number()
})

export const ActionPlanTriggersSystemViews = {
  TriggerBase,
  ManualTriggerMixin: Models.ManualTriggerMixin,
  ManualWithOutfittersMixin: Models.ManualWithOutfittersMixin,
  ManualWithOutfitters: Models.ManualWithOutfitters,
  Manual: Models.Manual,
  TriggerUnion: Models.TriggerUnion
}

export type ActionPlanTriggersSystemViews = {
  [key in keyof typeof ActionPlanTriggersSystemViews]: z.infer<(typeof ActionPlanTriggersSystemViews)[key]>
}
